import { Box, Divider, HStack, Stack, VStack, } from '@chakra-ui/react';
import React from 'react';
import COLORS from '../../../constants/colors';
import FONTS from '../../../constants/fonts';
import Text from '../../content/text';
import Container from '../container';
import Icon from '../../content/icon';
export const PageWebAuth = ({ children, onGoBack, title, }) => {
    // Render
    return (<VStack w="full" h="100vh" justifyContent={'center'} backgroundSize="cover" backgroundPosition="center" position="relative" _before={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bg: `radial-gradient(circle at top right, ${COLORS.Govrn.Blue.T500.value}1A, transparent 50%)`,
            zIndex: 0,
        }}>
      <VStack bgColor={COLORS.White.T500.value} w="full" maxW="35.75rem" rounded="1.25rem" overflow={'hidden'} spacing={0} boxShadow="0 10px 30px rgba(0, 0, 0, 0.15)" position="relative" zIndex={1} transition="transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out" _hover={{
            boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
        }}>
        {onGoBack ? (<>
            <HStack backgroundColor={COLORS.White.T500.value} py={'1.5rem'} px={'2.5rem'} width={'full'} justifyContent={'space-between'}>
              <Stack onClick={onGoBack} cursor="pointer" p={2} borderRadius="md" _hover={{ bg: COLORS.BG.value }} transition="background-color 0.2s">
                <Icon name="chevron-left-default"/>
              </Stack>
              <Text font={FONTS.T1.T16Px.SemiBold600.value ||
                FONTS.T1.T14Px.Medium500.value} color={COLORS.Text.T500.value}>
                {title}
              </Text>
              <Box height={'.875rem'} width={'.875rem'}/>
            </HStack>
            <Divider />
          </>) : (<Container style={{
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 40,
                marginBottom: 20,
            }}>
            <Icon name="application-logo" width={140} height={46}/>
          </Container>)}
        <Box width="full" px={8} py={6} borderRadius="lg">
          {children}
        </Box>
      </VStack>
      <Text font={FONTS.T1.T12Px.Regular400.value} color={COLORS.White.T500.value} mt={4} opacity={0.8}>
        © {new Date().getFullYear()} Govrn NV/SA
      </Text>
    </VStack>);
};
